import { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { organizationsAPI } from '../services/apiService';
import { clearSessionCookie } from '../utils/sessionCookie';
import PlatformDashboard from './PlatformDashboard';
import { AppShell, accountFrom } from '../olli/components/AppShell';
import { isConverted } from '../olli/state/converted';
import './Dashboard.css';

/**
 * The page frame every signed-in route renders inside: <Dashboard>{page}</Dashboard>.
 *
 * It is now the new Olli design's frame (src/olli/components/AppShell.js).
 * Pages already rebuilt in the new design render as they are; every other
 * page is an old page and sits in `.olli-legacy`, with the padding the old
 * frame gave it, so it looks exactly as it did.
 */
const Dashboard = ({ children }) => {
    const navigate = useNavigate();
    const location = useLocation();
    const [user, setUser] = useState(null);
    const [clinicName, setClinicName] = useState('');

    useEffect(() => {
        const userData = localStorage.getItem('user');
        const parsed = userData ? JSON.parse(userData) : null;
        if (parsed) setUser(parsed);
        organizationsAPI.getMyOrganizations()
            .then((response) => {
                if (!response.data.success) return;
                const orgs = response.data.data || [];
                const mine = orgs.find((o) => o.id === parsed?.organization_id) || orgs[0];
                if (mine?.name) setClinicName(mine.name);
            })
            .catch((err) => console.error('Failed to fetch organizations:', err));
    }, []);

    const handleLogout = () => {
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        clearSessionCookie();
        window.dispatchEvent(new Event('auth:logout'));
        navigate('/login');
    };

    const page = children ? children : <PlatformDashboard />;

    return (
        <AppShell
            account={accountFrom(user?.name, clinicName)}
            onSignOut={handleLogout}
        >
            {isConverted(location.pathname) ? page : (
                <div className="olli-legacy p-4 sm:p-6 lg:p-8">{page}</div>
            )}
        </AppShell>
    );
};

export default Dashboard;
